var $ = jQuery.noConflict();

function send_main_form(result) {

    result = JSON.parse(result);

    var $mf = jQuery(this).closest("#main-form");
    var current_step = $mf.find('input[name="current-step"]');
    var steps = jQuery(this).closest('.content-wrapper').find('.steps');
    var $rw = $mf.find('.row.wrapper');
    var submit_btn = jQuery(this);

    if (current_step == 1) {
        current_step = 2;
        submit_btn.html("Pokračovať")
    } else if (current_step == 2) {
        current_step = 3;
        submit_btn.html("Odoslať");
    }

    steps.find('.step').removeClass('active');
    steps.find('.step-' + current_step).addClass('active');
    $rw.addClass('step-' + current_step);

}

function send_contact_form(result){

}

function registration_school_complete(form, result){
    
    //reset data
    form.find('input[type=checkbox]').each(function(){
        $(this).val("");
        $(this).prop( "checked", false );
        $(this).closest('.form-group').removeClass('used').removeClass('checked');
    });
    form.find('input').each(function(){
        $(this).val("");
        $(this).closest('.form-group').removeClass('used');
    });
    form.find('textarea').each(function(){
        $(this).val('');
        $(this).closest('.form-group').removeClass('used');
    });

    // reset select2
    form.find('select').val(null).trigger('change');

    // reset file
    var file = window.form_files['form_registration_school']['file'];
    file.filepond('removeFiles');

    $('#registration-school-success-modal').modal();
}

function registration_complete(form, result){

    //reset data
    form.find('input[type=checkbox]').each(function(){
        $(this).val("");
        $(this).prop( "checked", false );
        $(this).closest('.form-group').removeClass('used').removeClass('checked');
    });
    form.find('input').each(function(){
        $(this).val("");
        $(this).closest('.form-group').removeClass('used');
    });
    form.find('textarea').each(function(){
        $(this).val('');
        $(this).closest('.form-group').removeClass('used');
    });

    // reset select2
    form.find('select').val(null).trigger('change');

    // reset file
    var file = window.form_files['form_registration']['file'];
    file.filepond('removeFiles');

    $('#registration-success-modal').modal();

}

function default_success_function(form, result){

    console.log(result);
    console.log(form);

    //reset data
    form.find('input[type=checkbox]').each(function(){
        $(this).val("");
        $(this).prop( "checked", false );
        $(this).closest('.form-group').removeClass('used').removeClass('checked');
    });
    form.find('input').each(function(){
        $(this).val("");
        $(this).closest('.form-group').removeClass('used');
    });
    form.find('textarea').each(function(){
        $(this).val('');
        $(this).closest('.form-group').removeClass('used');
    });

    // reset select2
    form.find('select').val(null).trigger('change');

    // reset file
    var file = window.form_files['form_registration']['file'];
    file.filepond('removeFiles');

    if(result.message != undefined && result.message != ""){
        form.find('.alert.success .text').html(result.message);
    }

    form.find('.alert.success').show();

}

function filter_competitors_success(form, result){
    console.log("filter success");
    $('.page-vote .competitors-list').html(result.html);
}

function filter_competitors_complete(form, result){
    console.log("filter complete");
    $('.page-vote .result .spinner-wrapper').fadeOut();
}

function filter_competitors_before_send(form, data){
    console.log("filter before send");
    $('.page-vote .result .spinner-wrapper').fadeIn();
}

function filter_help_success(form, result){
    console.log("filter help success");
    $('.page-help .items-list').html(result.html); 
}

function filter_help_complete(form, result){
    console.log("filter help complete");
    $('.page-help .result .spinner-wrapper').fadeOut();
}

function filter_help_before_send(form, data){
    console.log("filter help before send");
    $('.page-help .result .spinner-wrapper').fadeIn();
}

exports.send_main_form = send_main_form;
exports.send_contact_form = send_contact_form;
exports.default_success_function = default_success_function;
exports.registration_complete = registration_complete;
exports.registration_school_complete = registration_school_complete;
exports.filter_competitors_complete = filter_competitors_complete;
exports.filter_competitors_before_send = filter_competitors_before_send;
exports.filter_competitors_success = filter_competitors_success;
exports.filter_help_complete = filter_help_complete;
exports.filter_help_before_send = filter_help_before_send;
exports.filter_help_success = filter_help_success;


// WEBPACK FOOTER //
// ./assets/js/result_functions.js